export default {
  data() {
    return {
      other: {},
      swiper: {}
    }
  },
  created() {
    this.other = new Proxy(this.other, {
      get(target, prop) {
        return target[prop] || 0
      }
    })
  },
  methods: {
    toLeft(className) {
      const ele = this.swiper[className]
      const goodsWidth = `${className}GoodsWidth`
      if (!ele || !ele.maxStep || ele.step <= 0) return
      if (ele.step <= 1) {
        ele.step--
        ele[goodsWidth] = 0
      } else {
        ele.step--
        ele[goodsWidth] += ele.visibleCount * ele.distance
      }
    },
    toRight(className) {
      const ele = this.swiper[className]
      const goodsWidth = `${className}GoodsWidth`
      if (ele) {
        if (!ele.maxStep || ele.step >= ele.maxStep) return
        if (ele.step === ele.maxStep - 1) {
          ele.step++
          // 直接滚动到最后
          ele[goodsWidth] = - ele.totalCount * ele.distance + ele.fatherWidth + 10
        } else if (ele.step < ele.maxStep) {
          ele.step++
          ele[goodsWidth] -= ele.visibleCount * ele.distance
        }
      } else {
        let father = document.querySelector(`.${className}`)
        let son = father.querySelector('.list-content').children
        let distance = son[0].clientWidth + 10
        let fatherWidth = father.clientWidth - parseInt(getComputedStyle(father)['padding-left']) * 2
        let visibleCount = Math.floor(fatherWidth / distance) // 显示区域商品数量
        let totalCount = son.length // 商品总数量
        let maxStep = Math.ceil(totalCount / visibleCount) - 1
        
        this.$set(this.swiper, className, {
          father: father,
          fatherWidth: fatherWidth,
          visibleCount: visibleCount,
          totalCount: father.querySelector('.list-content').children.length,
          maxStep: maxStep,
          step: 0,
          [goodsWidth]: 0,
          distance: distance
        })
        this.toRight(className)
      }
    },
    otherToLeft(category) {
      let distance = document.querySelector('.other-content').querySelector('.goods-item').clientWidth+10
      let goodsWidth = `goodsWidth${category.category_id}`
      let newGoods = document.querySelector(`.other${category.category_id}`)
      let visibleCount = Math.floor(newGoods.clientWidth / distance)
      if (this.other[goodsWidth] < 0) {
        this.other[category.category_id] -= 1
        this.other[goodsWidth] += distance * visibleCount
        if (this.other[goodsWidth] > 0) {
          this.other[goodsWidth] = 0
        }
      }
    },
    otherToRight(category) {
      let distance = document.querySelector('.other-content').querySelector('.goods-item').clientWidth+10
      let flag = category.category_id
      let goodsWidth = `goodsWidth${category.category_id}`
      this.$set(this.other, flag, this.other[flag] || 0)
      this.$set(this.other, goodsWidth, this.other[goodsWidth] || 0)
      let newGoods = document.querySelector(`.other${category.category_id}`)
      let visibleCount = Math.floor(newGoods.clientWidth / distance)
      let padding
      if (window.getComputedStyle) {
        padding = Number.parseInt(window.getComputedStyle(newGoods).getPropertyValue('padding-left')) * 2
      } else {
        padding = Number.parseInt(newGoods.currentStyle.getPropertyValue('padding-left')) * 2
      }
      let bannerWidth = newGoods.offsetWidth - padding
      let goodsList = newGoods.getElementsByClassName('goods-item').length
      let step = Math.ceil((goodsList - Math.floor(bannerWidth / distance)) / visibleCount)
      this.other[flag] += 1
      if (this.other[flag] < step) {
        this.other[goodsWidth] -= distance * visibleCount
      } else if (this.other[flag] == step) {
        this.other[goodsWidth] = -goodsList * distance + bannerWidth
      } else {
        return this.other[flag] = step
      }
    }
  }
}


// WEBPACK FOOTER //
// ./resources/js/lib/mixins/swiper.js